import { render } from "./DialogMSG.vue?vue&type=template&id=339f6e82&scoped=true"
import script from "./DialogMSG.vue?vue&type=script&lang=js"
export * from "./DialogMSG.vue?vue&type=script&lang=js"

import "./DialogMSG.vue?vue&type=style&index=0&id=339f6e82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339f6e82"]])

export default __exports__